
export class ProjectMappingRequestModel {
  // projectCode : string;
  // projectName : string;
  // projectDescription : string;
  // updatedUser ?: string;
  // createdUser ?: string;
  // versionFlag: number;
}

export const ProjectMappingRequestDefault: ProjectMappingRequestModel = {
  // projectCode: '',
  // projectName : '',
  // projectDescription : '',
  // versionFlag: 0,
  // updatedUser: '',
  // createdUser: ''
}

